import styled, { css } from 'styled-components';
import { colorCSS } from '../../../styles';
const tabCSS = css `
  align-items: center;
  align-self: stretch;
  color: ${colorCSS('N800')};
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  padding: 1.25rem 1rem 1rem;
  user-select: none;
  &:hover {
    color: ${colorCSS('B300')};
  }
`;
export const Link = styled.a `
  ${tabCSS}
  text-decoration: none;
`;
export const Tab = styled.button `
  ${tabCSS}
  border: 0;
  background-color: transparent;
  gap: 0.25rem;
  svg {
    width: 0.5rem;
    height: auto;
  }
  &[data-active='true'] {
    color: ${colorCSS('B300')};
  }
`;
export const TabGroup = styled.div `
  display: flex;
  position: relative;
`;
export const Underline = styled.div `
  background-color: ${colorCSS('B300')};
  bottom: 0;
  height: 2px;
  position: absolute;
  transition: left 0.3s ease, width 0.3s ease;
`;
//# sourceMappingURL=Tabs.styles.js.map